<template>
	<div class="pickList-body">
		<!-- <div class="shop-position">
			<img src="~/images/icon/position-icon.png">
			当前卖家店铺：
			<el-select size="mini" v-model="shopId" @change='shopChange' placeholder="请选择">
				<el-option
				v-for="item in shopOptions"
				:key="item.shopId"
				:label="item.shopName"
				:value="item.shopId"/>
			</el-select>
		</div> -->
		<div class="menu-box">
			拣货清单
		</div>
		<div class="pickList-content-body">
			<div class="fx-title">
				<p>客户信息</p>
			</div>
			<el-form :model="ruleForm"  ref="ruleForm" label-width="150px" class="form-box">
				<el-form-item label="下单时间：">
					<el-date-picker
						class='long-input'
						@change='dateChange'
						v-model="ruleForm.dateValue"
						:unlink-panels='true'
						size="small"
						:clearable='true'
						:default-time="['00:00:00', '23:59:00']"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm'>
					</el-date-picker>
				</el-form-item>
					<el-form-item label="备货时间：">
					<el-date-picker
						class='long-input'
						@change='dateChange3'
						v-model="ruleForm.dateValue3"
						:unlink-panels='true'
						size="small"
						:clearable='true'
						:default-time="['00:00:00', '23:59:00']"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm'>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="期望到货时间：">
					<el-date-picker
						class='long-input'
						@change='dateChange2'
						v-model="ruleForm.dateValue2"
						:unlink-panels='true'
						size="small"
						:clearable='true'
						:default-time="['00:00:00', '23:59:00']"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm'>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="订单状态：">
					<el-select class='long-input' v-model="ruleForm.orderStatus" size='small' placeholder="请选择">
						<el-option :value='1' label='待接单'></el-option>
						<el-option :value='2' label='待发货'></el-option>
						<el-option :value='3' label='待收货'></el-option>
						<el-option :value='4' label='已完成'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品发货状态：" v-if="ruleForm.orderStatus === 2">
					<el-select class='long-input' v-model="ruleForm.pStatus" size='small' placeholder="请选择">
						<el-option :value='-1' label='全部'></el-option>
						<el-option :value='0' label='未发货'></el-option>
						<el-option :value='1' label='已发货'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="锁定状态：" v-if="ruleForm.orderStatus === 1">
					<el-select class='long-input' v-model="ruleForm.lockStatus" size='small' placeholder="请选择">
						<el-option :value='-1' label='全部'></el-option>
						<el-option :value='1' label='是'></el-option>
						<el-option :value='0' label='否'></el-option>
					</el-select>
				</el-form-item>
				<div class="fx-title">
					<p>筛选方式</p>
				</div>
				<el-form-item label="店铺级大类：">
					<el-select v-model="ruleForm.bcId" class="long-input" size='small' @change="bcChange">
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in bc">
							<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
						</template>
					</el-select>
				</el-form-item>
				<el-form-item label="店铺级小类：" v-if='bigcategoryview === 1'>
					<el-select v-model="ruleForm.scId" class="long-input" size='small'>
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in sc">
							<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
						</template>
					</el-select>
				</el-form-item>
				<el-form-item label="商品名称：">
					<el-input class='long-input' v-model="ruleForm.pName" size='small' placeholder='请输入商品名称' ></el-input>
				</el-form-item>
				<el-form-item label="客户类别：">
					<el-select v-model="ruleForm.cusType" class="long-input" size='small' @change="getCusNameList">
						<el-option value="0" label="全部"></el-option>
						<el-option v-for="(item,index) in customercategoryList" :key='index'  :value="item.ccid" :label="item.ccname"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="客户名称：">
					<!-- <el-input class='input-box' v-model="ruleForm.cusName" size='small' placeholder='请输入客户名称' ></el-input> -->
					<el-select
						class="long-input"
						size="small"
						v-model="ruleForm.customerIds"
						filterable
						multiple
						collapse-tags
						placeholder="请选择客户">
						<template v-for="item in customerOptions">
							<el-option
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</template>
					</el-select>
				</el-form-item>
				<el-form-item label="线路：">
					<!-- <el-select v-model="ruleForm.lineId" filterable class="input-box" size='small'>
						<el-option value="-1" label="全部"></el-option>
						<el-option v-for="(item,index) in roadList" :key='index'  :value="item.lineid" :label="item.codeandname"></el-option>
					</el-select> -->
					<el-select
						class="long-input"
						size="small"
						v-model="ruleForm.lineId"
						filterable
						multiple
						collapse-tags
						placeholder="请选择线路">
						<template v-for="item in roadList">
							<el-option
								:key="item.lineid"
								:label="item.codeandname"
								:value="item.lineid">
							</el-option>
						</template>
					</el-select>
				</el-form-item>
				<div class="fx-title">
					<p>显示方式</p>
				</div>
				<el-form-item label="店铺级大类：">
					<el-radio-group v-model="ruleForm.showBig">
						<el-radio :label="1">显示</el-radio>
						<el-radio :label="0">不显示</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="店铺级小类：" v-if='bigcategoryview === 1'>
					<el-radio-group v-model="ruleForm.showSmall">
						<el-radio :label="1">显示</el-radio>
						<el-radio :label="0">不显示</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="商品排序：">
					<el-radio-group v-model="ruleForm.pSort">
						<el-radio :label="0">商品编号</el-radio>
						<el-radio :label="1">商品顺序号</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="显示内容：">
					<el-checkbox-group v-model="ruleForm.showContent">
						<el-checkbox :label="0">总计</el-checkbox>
						<el-checkbox :label="1">小计</el-checkbox>
						<el-checkbox :label="2">订单明细数</el-checkbox>
						<el-checkbox :label="3">路线小计</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="排列方式：">
					<el-radio-group v-model="ruleForm.showType">
						<el-radio :label="0">商品纵向排序，客户横向排序</el-radio>
						<el-radio :label="1">客户纵向排序，商品横向排序</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
		</div>
		<div class="pickList-foot">
			<el-button class="btn" type="primary" size='small' @click='searchClick'>查询</el-button>
			<el-button class="btn" plain size='small' @click='reloadAll'>清空</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'valetOrder',
	data () {
		return {
			ruleForm: {
				lineId: [],
				showBig: 0,
				showSmall: 0,
				bcId: '0',
				scId: '0',
				pStatus: 0,
				pName: '',
				cusType: '0',
				customerIds: [],
				showType: 0,
				pSort: 0,
				dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59'],
				showContent: [0, 1, 2, 3],
				dateValue2: [],
				dateValue3: [],
				orderStatus: 2,
				lockStatus: -1
			},
			shopOptions: [],
			customercategoryList: [],
			roadList: [],
			sc: [],
			bc: [],
			shopId: '',
			shopName: '',
			bigcategoryview: 0,
			customerOptions: []
		}
	},
	created () {
		this.findShopList()
		this.getBigCategory()
		this.checkSmallCategory()
		this.getCustomercategory()
		this.getLineList()
		this.findCustomer()
		if (window.sessionStorage.getItem('pickListData')) {
			this.ruleForm = JSON.parse(window.sessionStorage.getItem('pickListData'))
			this.sc = this.ruleForm.sc
		}
	},
	methods: {
		getLineList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/line/listfilter`
			}).then(res => {
				this.roadList = res
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// shopChange () {
		// 	var list = this.shopOptions
		// 	for (var i = 0; i < list.length; i++) {
		// 		if (this.shopId === list[i].shopId) {
		// 			this.shopName = list[i].shopName
		// 		}
		// 	}
		// },
		getCustomercategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customercategoryList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
			// })
		},
		bcChange (value) {
			this.ruleForm.bcId = '' + value
			this.ruleForm.scId = '0'
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		getSmalCategory () {
			let params = {
				pid: this.ruleForm.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		searchClick () {
			if (this.ruleForm.showContent.length === 0) {
				this.$message.error('请选择显示内容')
				return false
			}
			if ((this.ruleForm.dateValue === null || this.ruleForm.dateValue.length === 0) && (this.ruleForm.dateValue2 === null || this.ruleForm.dateValue2.length === 0) && (this.ruleForm.dateValue3 === null || this.ruleForm.dateValue3.length === 0)) {
				this.$message.error('请选择查询时间！')
				return false
			}
			this.ruleForm.beginDate = this.ruleForm.dateValue === null ? '' : this.ruleForm.dateValue[0]
			this.ruleForm.endDate = this.ruleForm.dateValue === null ? '' : this.ruleForm.dateValue[1]
			this.ruleForm.wantArrivalBeginDate = this.ruleForm.dateValue2 === null ? '' : this.ruleForm.dateValue2[0]
			this.ruleForm.wantArrivalEndDate = this.ruleForm.dateValue2 === null ? '' : this.ruleForm.dateValue2[1]
			this.ruleForm.prepareBeginDate = this.ruleForm.dateValue3 === null ? '' : this.ruleForm.dateValue3[0]
			this.ruleForm.prepareEndDate = this.ruleForm.dateValue3 === null ? '' : this.ruleForm.dateValue3[1]
			this.ruleForm.shopName = this.shopName
			this.ruleForm.shopId = this.shopId
			this.ruleForm.bigcategoryview = this.bigcategoryview
			this.ruleForm.pStatus = this.ruleForm.orderStatus === 2 ? this.ruleForm.pStatus : -1
			this.ruleForm.lockStatus = this.ruleForm.orderStatus === 1 ? this.ruleForm.lockStatus : -1
			this.ruleForm.sc = this.sc
			var data = JSON.stringify(this.ruleForm)
			window.sessionStorage.setItem('pickListData', data)
			// this.$fxGoBlank('/pickListTable', this.$router)
			this.$router.push('/main/pickListTable')
		},
		reloadAll () {
			this.ruleForm = {
				showBig: 0,
				showSmall: 0,
				bcId: '0',
				scId: '0',
				pStatus: 0,
				pName: '',
				cusType: '0',
				customerIds: [],
				showType: 0,
				pSort: 0,
				lineId: [],
				dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59'],
				dateValue2: [],
				dateValue3: [],
				showContent: [0, 1, 2, 3],
				orderStatus: 2,
				lockStatus: -1
			}
		},
		dateChange () {
			if (this.ruleForm.dateValue === null) {
				this.ruleForm.dateValue = []
			}
		},
		dateChange2 () {
			if (this.ruleForm.dateValue2 === null) {
				this.ruleForm.dateValue2 = []
			}
		},
		dateChange3 () {
			if (this.ruleForm.dateValue3 === null) {
				this.ruleForm.dateValue3 = []
			}
		},
		findShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
			}).then(res => {
				if (res.result) {
					this.shopOptions = res.data.shop
					if (res.data.shop.length > 0) {
						this.shopId = res.data.shop[0].shopId
						this.shopName = res.data.shop[0].shopName
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		findCustomer () {
			let params = {
				name: '',
				customercategoryid: this.ruleForm.cusType === '0' ? '-1' : this.ruleForm.cusType
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerInfoForCondition`,
				data: params
			}).then(res => {
				this.customerOptions = res.data
			})
		},
		getCusNameList () {
			this.findCustomer()
		}
	}
}
</script>

<style lang="stylus" scoped>
.pickList-body {
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.menu-box {
		height: 50px
		line-height: 50px
		// text-indent: 30px
		text-align: left
		font-size: 16px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
	}
	.pickList-content-body {
		flex :1;
		min-height :1px;
		overflow-y: auto;
		.fx-title {
			font-weight: 700
			margin: 20px 0 10px 0
		}
		.form-box{
			width :650px;
			display :flex;
			flex-direction: column;
			text-align: left;
		}
		.long-input{
			width :300px
		}
		.input-box{
			width :200px
		}
	}
	.pickList-foot {
		height :40px;
		margin-bottom :10px;
		.btn{
			width :130px;
			height :35px;
			margin: 0 30px
        }
	}
}
</style>
